export const OverflowMenuSearchComponentModule = angular
    .module('app.components.pageHeader.overflowMenuSearch', [])
    .component('overflowMenuSearch', {
        template: `
            <md-menu-item>
                <md-button ng-click="$ctrl.onClick()">Search</md-button>
            </md-menu-item>
        `,
        bindings: {
            onClick: '&'
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/pageHeader/overflowMenu/overflowMenuSearch.js